<template>
  <div>
    <el-form-item label="跳转目标">
      <el-select
        class="search-el"
        v-model="theTarget"
        placeholder="请选择"
        clearable
        :change="changeTarget()"
      >
        <el-option
          v-for="(v, k) in bannerTargetList"
          :key="k"
          :label="v"
          :value="k"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="H5地址" v-show="theTarget == 'target_h5'">
      <el-input v-model="theAddress" style="width: 66%"></el-input>
      <div style="color: red">不输入链接，用户端点击banner无反应（点击不会跳转）</div>
    </el-form-item>

    <el-form-item
      label="跳转目的"
      v-show="
        [
          'live_detail',
          'course_detail',
          'workshop_detail',
          'book_detail',
          'product_detail',
          'course_package',
          'consult_detail',
          'brokerage_course_detail',
          'brokerage_workshop_detail',
          'brokerage_product_detail'
        ].indexOf(theTarget) >= 0
      "
    >
      <el-input v-model="the_target_msg" style="width: 33%" disabled></el-input>
      <el-button
        type="primary"
        size="small"
        @click="
          search.chooseOrgVisible = true;
          searchData();
        "
      >
        查询
      </el-button>
    </el-form-item>

    <el-dialog
      title="选择"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { screenProductList } from "@/api/coupon";

import { getBannerTargetList } from "@/api/banner";

import { getZbBannerTargetList } from "@/api/banner";
export default {
  name: "bannerTarget",
  props: {
    target: {
      type: String,
      default: "",
    },
    target_id: {
      type: Number,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    target_msg: {
      type: String,
      default: "",
    },
    source_type: {
      type: Number,
      default: "",
    },
  },
  data: function () {
    return {
      bannerTargetList: [],
      tmpTarget: "",
      theTarget: this.target, //theTarget:子组件变量，允许更新，this.target：父组件传递过来的变量，是不能更新的，通过更新子组件变量，父组件获取该变量
      theAddress: this.address,
      the_target_msg: this.target_msg,
      theTargetId: this.target_id,
      theSourceType: this.source_type,
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    if (this.theSourceType === 1) {
      getZbBannerTargetList().then((response) => {
        this.bannerTargetList = response.data;
      });
    } else {
      getBannerTargetList().then((response) => {
        this.bannerTargetList = response.data;
      });
    }
  },
  methods: {
    //下拉框更新动作
    changeTarget() {
      if (this.theTarget != this.tmpTarget) {
        this.theTargetId = 0;
        this.the_target_msg = "";
        this.theAddress = "";
      }
      this.tmpTarget = this.theTarget;
      this.$emit('target1', this.theTarget);
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      if (this.theTarget == "live_detail") this.search.query.target_type = 3;
      if (this.theTarget == "course_detail" || this.theTarget == "brokerage_course_detail") this.search.query.target_type = 1;
      if (this.theTarget == "workshop_detail" || this.theTarget == "brokerage_workshop_detail")
        this.search.query.target_type = 5;
      if (this.theTarget == "book_detail") this.search.query.target_type = 6;
      if (this.theTarget == "product_detail" || this.theTarget == "brokerage_product_detail") this.search.query.target_type = 0;
      if (this.theTarget == "course_package") this.search.query.target_type = 12;
      if (this.theTarget == "consult_detail") this.search.query.target_type = 16;
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.theTargetId = row.id;
      this.the_target_msg =
        this.bannerTargetList[this.theTarget] + "， ID： " + this.theTargetId;

      this.addEditFormOnClose();
    },
  },
  watch: {
    target(v) {
      this.theTarget = this.tmpTarget = v;
    },
    target_id(v) {
      this.theTargetId = v;
    },
    target_msg(v) {
      this.the_target_msg = v;
    },
    address(v) {
      this.theAddress = v;
    },
  },
};
</script>

<style>
</style>